import React, { createContext, useContext, useMemo, useState } from "react";

import { MedicalPlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: MedicalPlan;
  planCost: PlanCost;
}
interface MedicalContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: MedicalPlan | null;
  planCost: PlanCost | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const MedicalContext = createContext<MedicalContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: MedicalPlan;
  planCost: PlanCost;
}
export const MedicalContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<MedicalPlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      hide();
    };
    return { openEnrollmentModal, plan: _plan, planCost: _planCost, isShowing, hideEnrollmentModal };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <MedicalContext.Provider value={contextValue}>{children}</MedicalContext.Provider>;
};

export const useMedicalContext = () => useContext(MedicalContext);
